<template>
  <div>
    <a-row style="padding-bottom: 12px">
      <a-radio-group
        name="radioGroup"
        v-model="selectedType"
        :default-value="options?.[0]?.value"
      >
        <a-radio
          v-for="option in options"
          :key="option.value"
          :value="option.value"
          class="media-export__radio"
          defaultValue="banner"
        >
          {{ option.name }}
        </a-radio>
      </a-radio-group>
    </a-row>
    <a-row v-if="usePeriod" class="mb-4">
      <ActivityPeriods
        ref="activity-periods"
        :periods="selectedPeriod"
        :showIndex="false"
        :required="false"
        :buttonPos="null"
        :returnUTC="returnUTC"
        showLabel
      >
        <template #label>
          Period
        </template>
      </ActivityPeriods>
    </a-row>
    <a-row class="footer-modal">
      <a-col class="text-right" :span="24">
        <a-button @click="closeModal"> Cancel </a-button>
        <a-button
          :loading="loading"
          type="primary"
          @click="startExport"
          class="ml-2"
        >
          Export
        </a-button>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import ActivityPeriods from '@/components/custom/ActivityPeriods.vue'

export default {
  name: 'selectExportType',
  components: {
    ActivityPeriods,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    usePeriod: {
      type: Boolean,
      default: false,
    },
    returnUTC: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: false,
    selectedType: '',
    selectedPeriod: [
      {
        startsAt: null,
        endsAt: null,
      },
    ],
  }),
  computed: {},
  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
    async startExport() {
      if (this.usePeriod) {
        const periodsValid = await this.$refs['activity-periods']?.validate()

        if (!periodsValid) {
          return
        }

        this.selectedPeriod = this.$refs['activity-periods'].getPeriods()
      }

      this.$emit('select', { type: this.selectedType, period: this.selectedPeriod[0] })
    },
  },
  async created() {
    this.selectedType = this.options?.[0]?.value ?? ''
  },
}
</script>

<style lang="scss"></style>
